// extracted by mini-css-extract-plugin
export default {"linksRow":"FooterLinks_linksRow__MJukh","footerLink":"FooterLinks_footerLink__1mrPC"};